var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"PaB-app__header"},[_c('div',{staticClass:"PaB-app-actions"},[_c('search-form'),_c('view-controls',{attrs:{"isHome":_vm.isHome}})],1),_c('active-filters'),_c('category-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }